import { __classPrivateFieldGet } from './external_node_modules/tslib/tslib.es6.js';
import { ENVIRONMENTS } from './constants/environments.js';
import { LOG_LEVELS } from './constants/logLevels.js';
import { PLATFORMS } from './constants/platforms.js';

var _DevSettings_instances, _DevSettings_keys, _DevSettings_parseFromUrl;
class DevSettings {
    constructor(settings) {
        this.settings = settings;
        _DevSettings_instances.add(this);
        _DevSettings_keys.set(this, [
            'language',
            'storefrontName',
            'useClientMocks',
            'platform',
            'environment',
            'country',
            'purchaseDisabled',
            'accountCompletionEnableForce',
        ]);
        __classPrivateFieldGet(this, _DevSettings_instances, "m", _DevSettings_parseFromUrl).call(this);
    }
    saveToUrl() {
        const settings = {};
        for (const key of __classPrivateFieldGet(this, _DevSettings_keys, "f")) {
            if (this.settings[key]) {
                settings[key] = this.settings[key];
            }
        }
        window.location.search = new URLSearchParams(settings).toString();
    }
}
_DevSettings_keys = new WeakMap(), _DevSettings_instances = new WeakSet(), _DevSettings_parseFromUrl = function _DevSettings_parseFromUrl() {
    const params = new URLSearchParams(window.location.search);
    for (const key of __classPrivateFieldGet(this, _DevSettings_keys, "f")) {
        const value = params.get(key);
        if (value) {
            this.settings[key] = value;
        }
    }
};
class SettingsStore {
    constructor() {
        this.dev = null;
        this.language = '';
        this.showDevPanel = false;
        this.logLevel = LOG_LEVELS.DEBUG;
        this.backendUrl = '';
        this.storefrontName = '';
        this.storefrontUrl = '/{language}/api/{platform}/storefront/{storefrontName}/';
        this.productsValidationEnabled = true;
        this.productsValidateUrl = '/{language}/api/{platform}/validate_storefront/{storefrontName}/';
        this.dwhExportEnabled = true;
        this.dwhExportUrl = '';
        this.userInfoUrl = '/{language}/api/user/';
        this.userSupportUrl = '';
        this.userSetCountryUrl = '';
        this.egsPreparePurchaseUrl = '/{language}/api/{platform}/prepare_purchase/';
        this.egsCommitPurchaseUrl = '/{language}/api/{platform}/commit_purchase/';
        this.steamPurchasePrepareUrl = '/{language}/api/{platform}/prepare_purchase/';
        this.steamPurchaseStatusUrl = '/{language}/api/{platform}/transactions/{id}/purchase_status/';
        this.fraudDetectionDialogEnabled = true;
        this.fraudDetectionClosableByPlatform = true;
        this.webPurchaseConfirmationIframeStyles = {};
        this.webPurchaseConfirmationIframeAttributes = {};
        this.webPurchaseConfirmationIframeUrl = '/{language}/purchase_confirmation/{productCode}/{storefrontName}/{quantity}/';
        this.purchaseFreeProductUrl = '/{language}/api/{platform}/purchase_zero_price_product/';
        this.webPreparePurchaseUrl = '/{language}/api/{platform}/prepare_purchase/';
        this.webCommitPurchaseUrl = '/{language}/api/{platform}/commit_purchase/';
        this.webBindStatusUrl = '/{language}/api/{platform}/client_payment_method_binding/status/';
        this.webTsvMethodsUrl = '/{language}/api/{platform}/get_tsv_methods/';
        this.webTsvSmsStatusUrl = '/api/tsv/sms/status/';
        this.webTsvSmsDisableUrl = '/api/tsv/sms/disable/';
        this.webTsvSmsDisableConfirmationUrl = '/api/tsv/sms/disable/confirm/';
        this.webThreeDSStatusUrl = '/{language}/api/{platform}/transactions/{id}/3ds_status/';
        this.customPopupStyles = {};
        this.redirectToUserAuthEnabled = true;
        this.userAuthUrl = null;
        this.webGetProductVariablePriceUrl = '/{language}/api/{platform}/storefront/{storefrontName}/product/{productCode}/price/{quantity}/';
        this.analytics = {
            projectName: 'wsmart',
            sendInterval: 1,
            maxBatchSize: 3,
        };
        this.requestMaxAttempts = 5;
        this.environment = ENVIRONMENTS.PRODUCTION;
        this.accountCompletionEnableForce = false;
        this.accountCompletionCountries = ['RU', 'BY'];
        this.accountCompletionPlatforms = [PLATFORMS.STEAM, PLATFORMS.WIN_STORE, PLATFORMS.EGS];
        this.checkAccountCompletionTimeout = 2000;
        this.checkAccountCompletionRetryCount = 50;
        this.showMorePaymentMethodsCountries = ['BY'];
    }
    setSettings(settings) {
        Object.assign(this, settings);
        if (settings.showDevPanel) {
            this.dev = new DevSettings(this);
        }
    }
}
var settings = new SettingsStore();

export { SettingsStore, settings as default };
//# sourceMappingURL=settings.js.map
